import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f0e18b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mod_wrap" }
const _hoisted_2 = { class: "mod_c_title" }
const _hoisted_3 = { class: "mod_c_tbody" }
const _hoisted_4 = { class: "mod_c_tbody" }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "header" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header_name" }, "自定义类别：", -1))
const _hoisted_8 = { class: "header_list" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "item_ability"
}
const _hoisted_11 = { class: "chunk" }
const _hoisted_12 = { class: "chunk_head" }
const _hoisted_13 = { class: "flex" }
const _hoisted_14 = { class: "chunk_head" }
const _hoisted_15 = { class: "flex_al" }
const _hoisted_16 = { class: "chunk_list" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "mod_pagin" }

import CrumbVue from '@/components/Crumb.vue';
import { computed, nextTick, reactive, ref } from 'vue';
import { useRoute } from 'vue-router';
import { Tabs, Input, message, Upload, Checkbox, Table, Pagination, Tooltip, Modal } from 'ant-design-vue';
import { SearchOutlined } from '@ant-design/icons-vue';
import { FileInfo, FileItem } from '../Sensitive/sensitive';
import { getToken } from '@/plugins/cookie';
import {
  clickUpdataList,
  columns1,
  columns2,
  getcreateModalData,
  getCreateModalTitle,
  createModal,
  typeList,
  dataSource,
  pageConfig,
  headerListKey,
  getCommentList,
  getCommentRobotList,
  worksList,
  delModal,
  clickCloseList,
} from './review';
import { IColumns, ICommentT, ICommentT1, ICreateD, RootModal } from './type';
import CDelModal from '@/components/CDelModal.vue';
import CreateModal from './CreateModal.vue';
import { Key } from 'ant-design-vue/lib/_util/type';
import http from '@/api/robot';
import { useDebounce } from '@/hooks/useDebounce'; //防抖


export default /*#__PURE__*/_defineComponent({
  __name: 'RobotReview',
  setup(__props) {

const route = useRoute();
const aTabs = Tabs;
const aTabPane = Tabs.TabPane;
const aInputSearch = Input.Search;
const aUpload = Upload;
const aCheckbox = Checkbox;
const aTable = Table;
const aPagination = Pagination;
const aTooltip = Tooltip;
const aModal = Modal;

const activeKey = ref('1');
// tab 切换
const tabsChange = () => {
  dataSource.value = [];
  pageConfig.current = 1;
  selectedRowKeys.value = [];
  keywords.value = '';
  choiceCheck.value = false;
  if (activeKey.value === '1') {
    typeList.value = type_list_res1.value;
    headerListKey.value = typeList.value[0].id;
    getCommentList();
  } else {
    typeList.value = type_list_res2.value;
    headerListKey.value = typeList.value[0].id;
    getCommentRobotList();
  }
};

const type_list_res1 = ref<ICommentT[]>([]);
const type_list_res2 = ref<ICommentT[]>([]);
// 类型菜单切换
const clickTabs = useDebounce((id: number) => {
  headerListKey.value = id;
  dataSource.value = [];
  pageConfig.current = 1;
  if (activeKey.value === '1') {
    getCommentList();
  } else {
    getCommentRobotList();
  }
});
// 获取评论库、身份库类型列表
const get_type_list = () => {
  Promise.all([http.get_comment_type_list(), http.get_robot_identity_list()]).then(([res1, res2]) => {
    type_list_res1.value = res1.data.data.map((e: ICommentT1) => new ICommentT(e));
    type_list_res2.value = res2.data.data.map((e: ICommentT1) => new ICommentT(e));
    typeList.value = type_list_res1.value;
    headerListKey.value = typeList.value[0].id;
    getCommentList();
  });
};
get_type_list();

//搜索
const keywords = ref('');
const arrList = computed(() => JSON.parse(JSON.stringify(dataSource.value)));
const selectOption = () => {
  if (keywords.value) {
    const arr: any =
      activeKey.value === '1'
        ? arrList.value.filter((e: any) => e.content.includes(keywords.value))
        : arrList.value.filter((e: any) => e.name.includes(keywords.value));
    dataSource.value = arr;
  } else {
    dataSource.value = worksList.value;
  }
};
// 下载模板地址
const dowExcalUrl = computed(() =>
  activeKey.value === '1' ? process.env.VUE_APP_OTHER_LINK+'/comment.xlsx' : process.env.VUE_APP_OTHER_LINK+'/robot_comment.xlsx'
);

// 批量导入
const fileList = ref<FileItem[]>([]);
const actionUrl = computed(() =>
  activeKey.value === '1' ? '/api/v1/console/upload_msg_list' : '/api/v1/console/upload_robot_list'
);
const token = getToken();
// 导入接口传参
const upRobotData = computed(() => {
  let data: any = {};
  if (activeKey.value === '1') {
    data = { type_id: headerListKey.value };
  } else {
    data = { identity_id: headerListKey.value };
  }
  return data;
});
const handleChange = (info: FileInfo) => {
  if (info.file.status === 'done') {
    if (info.file?.response?.code === 200) {
      // message.success(info.file?.response?.message);
      activeKey.value === '1' ? getCommentList() : getCommentRobotList();
    }
    if (info.file?.response?.code === 100) {
      message.error(info.file?.response?.error);
    }
  }
};

const choiceCheck = ref(false); //全选
const columns = computed(() => (activeKey.value === '1' ? columns1 : columns2));
const selectedRowKeys = ref<Key[]>([]);
// 选择
const onSelectChange = (changableRowKeys: Key[]) => {
  selectedRowKeys.value = changableRowKeys;
  choiceCheck.value = selectedRowKeys.value.length === dataSource.value.length ? true : false;
};
// 全选
const clickAllSel = () => {
  if (choiceCheck.value) {
    selectedRowKeys.value = dataSource.value.map((e: any) => e.id);
  } else {
    selectedRowKeys.value = [];
  }
};
const disabledDel = computed(() => (selectedRowKeys.value.length === 0 ? true : false));
const getList = () => {
  if (activeKey.value === '1') {
    getCommentList();
  } else {
    getCommentRobotList();
  }
};

// 删除
const delModalType = ref();
const delContentId = ref();
const opendelModal = (type: number, id?: number) => {
  // 1类别删除   2多选内容删除     3单选内容删除
  delModalType.value = type;
  delModal.visible = true;
  id ? (delContentId.value = id) : '';
};

const closeDelModal = () => {
  delModal.visible = false;
  delContentId.value = undefined;
};

const closeContent = useDebounce(() => {
  const { delCommentType, delCommentContent, delRobotIdentityLibrary, delCommentRobot } = clickCloseList(
    headerListKey.value,
    delContentId.value ? delContentId.value : selectedRowKeys.value.join()
  );
  if (delModalType.value === 1) {
    activeKey.value === '1' ? delCommentType() : delRobotIdentityLibrary();
  } else {
    activeKey.value === '1' ? delCommentContent() : delCommentRobot();
  }
  delContentId.value = undefined;
});

// 添加类别内容、修改类别内容
const createModalData = ref<ICreateD>({
  avatal: '',
  avatalId: 0,
  content: '',
});
const createModalType = ref();
const createModalItem = ref();
const openCreateModal = (type: number, item?: any) => {
  // 评论库  0添加类别  1修改类别  2添加评论内容 3修改评论内容  身份库 4添加类别  5修改类别 6添加身份 7修改身份
  createModalType.value = type;
  createModal.visible = true;
  if (item) {
    createModalItem.value = item;
  }
  createModal.title = getCreateModalTitle(type);
  createModalData.value = getcreateModalData(type, item);
};
// 弹窗数据更新
const getUpdata = (data: ICreateD) => {
  createModalData.value = data;
};
const clickSave = useDebounce(() => {
  const {
    creataTypeComment,
    editTypeComment,
    creataCommentData,
    editCommentData,
    addRobotIdentity,
    editRobotIdentityLibrary,
    addUserCommentRobot,
    editUserReviewRobot,
  } = clickUpdataList(createModalData.value.content, headerListKey.value, createModalItem.value?.id);
  // 评论库  0添加类别  1修改类别  2添加评论内容 3修改评论内容  身份库 4添加类别  5修改类别 6添加身份 7修改身份
  switch (createModalType.value) {
    case 1:
      editTypeComment();
      break;
    case 2:
      creataCommentData();
      break;
    case 3:
      editCommentData();
      break;
    case 4:
      addRobotIdentity();
      break;
    case 5:
      editRobotIdentityLibrary();
      break;
    case 6:
      addUserCommentRobot(createModalData.value.avatal, createModalData.value.avatalId);
      break;
    case 7:
      editUserReviewRobot(createModalData.value.avatal, createModalData.value.avatalId);
      break;
    default:
      creataTypeComment();
      break;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CrumbVue),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(route).meta.title), 1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(aTabs), {
          type: "card",
          activeKey: activeKey.value,
          "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((activeKey).value = $event)),
          onChange: tabsChange
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(aTabPane), {
              key: "1",
              tab: "评论库"
            }),
            _createVNode(_unref(aTabPane), {
              key: "2",
              tab: "身份库",
              "force-render": ""
            })
          ]),
          _: 1
        }, 8, ["activeKey"]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(typeList), (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["header_list_item", { item_actived: _unref(headerListKey) === item.id }]),
                    key: item.id,
                    onClick: ($event: any) => (_unref(clickTabs)(item.id))
                  }, [
                    _createTextVNode(_toDisplayString(item.name) + " ", 1),
                    (_unref(headerListKey) === item.id)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          (activeKey.value === '1')
                            ? (_openBlock(), _createBlock(_component_a_button, {
                                key: 0,
                                type: "link",
                                class: "item_ability_btn",
                                onClick: _withModifiers(($event: any) => (openCreateModal(1, item)), ["stop"])
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_svg_icon, { "icon-class": "sensitive_action_set" })
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : (_openBlock(), _createBlock(_component_a_button, {
                                key: 1,
                                type: "link",
                                class: "item_ability_btn",
                                onClick: _withModifiers(($event: any) => (openCreateModal(5, item)), ["stop"])
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_svg_icon, { "icon-class": "sensitive_action_set" })
                                ]),
                                _: 2
                              }, 1032, ["onClick"])),
                          _createVNode(_component_a_button, {
                            type: "link",
                            class: "item_ability_btn",
                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (opendelModal(1)), ["stop"]))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_svg_icon, { "icon-class": "sensitive_action_del" })
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ], 10, _hoisted_9))
                }), 128)),
                (activeKey.value === '1')
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 0,
                      type: "link",
                      class: "header_list_create",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (openCreateModal(0)))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_svg_icon, { "icon-class": "sensitive_action_create" })
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_a_button, {
                      key: 1,
                      type: "link",
                      class: "header_list_create",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (openCreateModal(4)))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_svg_icon, { "icon-class": "sensitive_action_create" })
                      ]),
                      _: 1
                    }))
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  (activeKey.value === '1')
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 0,
                        type: "primary",
                        class: "mr_16",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (openCreateModal(2)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("添加评论")
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_a_button, {
                        key: 1,
                        type: "primary",
                        class: "mr_16",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (openCreateModal(6)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("添加身份")
                        ]),
                        _: 1
                      })),
                  _createVNode(_unref(aInputSearch), {
                    class: "mod_range_picker_search",
                    value: keywords.value,
                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((keywords).value = $event)),
                    placeholder: "搜索：关键字",
                    onSearch: selectOption
                  }, {
                    enterButton: _withCtx(() => [
                      _createVNode(_unref(SearchOutlined))
                    ]),
                    _: 1
                  }, 8, ["value"])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", null, _toDisplayString(activeKey.value === '1' ? '评论内容' : '身份内容'), 1),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_unref(aCheckbox), {
                    checked: choiceCheck.value,
                    "onUpdate:checked": _cache[7] || (_cache[7] = ($event: any) => ((choiceCheck).value = $event)),
                    disabled: _unref(dataSource).length === 0,
                    onChange: clickAllSel
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("全选")
                    ]),
                    _: 1
                  }, 8, ["checked", "disabled"]),
                  _createVNode(_component_a_button, {
                    class: "mod_btn",
                    type: "link",
                    danger: "",
                    disabled: _unref(disabledDel),
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (opendelModal(2)))
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_svg_icon, {
                        class: "mod_btn_icon",
                        "icon-class": "del"
                      })
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode("删除 ")
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_unref(aTable), {
                  class: "ant-table-striped",
                  columns: _unref(columns),
                  "data-source": _unref(dataSource),
                  "row-selection": { selectedRowKeys: selectedRowKeys.value, onChange: onSelectChange },
                  pagination: false,
                  showHeader: false,
                  "row-key": "id",
                  size: "small"
                }, {
                  avatal: _withCtx(({ record }) => [
                    (record.avatar_url)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: record.avatar_url,
                          class: "list_img"
                        }, null, 8, _hoisted_17))
                      : _createCommentVNode("", true)
                  ]),
                  operation: _withCtx(({ record }) => [
                    _createVNode(_unref(aTooltip), null, {
                      title: _withCtx(() => [
                        _createTextVNode("修改")
                      ]),
                      default: _withCtx(() => [
                        (activeKey.value === '1')
                          ? (_openBlock(), _createBlock(_component_a_button, {
                              key: 0,
                              type: "link",
                              onClick: ($event: any) => (openCreateModal(3, record))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_svg_icon, { "icon-class": "sensitive_updata" })
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : (_openBlock(), _createBlock(_component_a_button, {
                              key: 1,
                              type: "link",
                              onClick: ($event: any) => (openCreateModal(7, record))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_svg_icon, { "icon-class": "sensitive_updata" })
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_unref(aTooltip), null, {
                      title: _withCtx(() => [
                        _createTextVNode("删除")
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          type: "link",
                          onClick: ($event: any) => (opendelModal(3, record.id))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_svg_icon, { "icon-class": "sensitive_del" })
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }, 8, ["columns", "data-source", "row-selection"])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_unref(aPagination), {
                  "show-quick-jumper": "",
                  total: _unref(pageConfig).totalSize,
                  current: _unref(pageConfig).current,
                  "onUpdate:current": _cache[9] || (_cache[9] = ($event: any) => ((_unref(pageConfig).current) = $event)),
                  "page-size": _unref(pageConfig).pageSize,
                  "onUpdate:pageSize": _cache[10] || (_cache[10] = ($event: any) => ((_unref(pageConfig).pageSize) = $event)),
                  pageSizeOptions: _unref(pageConfig).options,
                  "show-less-items": "",
                  "show-size-changer": "",
                  onChange: getList,
                  onShowSizeChange: getList
                }, null, 8, ["total", "current", "page-size", "pageSizeOptions"])
              ])
            ])
          ])
        ])
      ]),
      _createVNode(CDelModal, {
        visible: _unref(delModal).visible,
        centered: "",
        close: closeDelModal,
        ok: _unref(closeContent)
      }, null, 8, ["visible", "ok"]),
      _createVNode(_unref(aModal), {
        visible: _unref(createModal).visible,
        "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((_unref(createModal).visible) = $event)),
        title: _unref(createModal).title,
        centered: "",
        onOk: _unref(clickSave)
      }, {
        default: _withCtx(() => [
          _createVNode(CreateModal, {
            createModalType: createModalType.value,
            modelValue: createModalData.value,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((createModalData).value = $event)),
            "onUpdata:data": getUpdata
          }, null, 8, ["createModalType", "modelValue"])
        ]),
        _: 1
      }, 8, ["visible", "title", "onOk"])
    ])
  ], 64))
}
}

})